import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { guardRoute } from "@/lib/policy/route-guard";
import { PlatformShelbyCard } from "./-components/platform-shelby-card";

export const Route = createFileRoute("/_authenticated/platform_/sales-assistant")({
  beforeLoad: ({ context }) => guardRoute(context.me, "platform-sales-assistant"),
  component: PlatformSalesAssistant,
});

/** Setting up Shelby on People AI's texting line. */
function PlatformSalesAssistant() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="People AI sales assistant"
        meta="Whether Shelby is on, how she sounds and who a ready buyer goes to."
      />
      <PlatformShelbyCard />
    </div>
  );
}
